import { useEffect, useState } from 'react'

import CloseButton from '../../../components/CloseButton/CloseButton'
import { useAppState } from '../../../context/appStateContext'
import { useBlackFriday } from '../../../context/blackFridayContext'
import useStrings from '../../../localization/useStrings'
import native from '../../../native/native'
import images from '../../../utils/images'
import Countdown from '../Countdown/Countdown'
import style from './PromoBanner.module.scss'
import { Textfit } from 'react-textfit'

const PromoBanner = () => {
  const strings = useStrings()

  const blackFriday = useBlackFriday()
  const isUltimate =
    blackFriday.state.isUltimate ||
    blackFriday.state.isPremiumUser ||
    blackFriday.state.isUltimateLaunch
  const initialData = useAppState().state.initialData
  const productData = useAppState().state.productData

  const pricing = isUltimate ? blackFriday.state.ultimatePricing : blackFriday.state.premiumPricing

  const savingPercentage = pricing.savingPercent

  const title = blackFriday.state.isUltimateLaunch
    ? strings.premiumToUltimateBlackFriday.ultimateLaunch.bannerTitle
    : strings.blackFridayTitle

  let containerStyle: any = isUltimate ? {} : { backgroundColor: "#272c39" }

  const titleClass = isUltimate ? `${style.title} ${style.titleUltimate}` : style.title

  const icon = isUltimate ? images.ultimate.blackFriday.bannerIcon : images.blackFridayIcon

  const isAlbumList = initialData?.source == "albumListTop"

  const closeVisible = isAlbumList

  if (!isAlbumList) {
    containerStyle.borderRadius = 12
  }

  const [visible, setVisible] = useState(false)

  const promoHours = 72

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 300)
    return () => clearTimeout(timer)
  }, [])

  return (
    <div
      className={`${style.container} ${visible ? style.fadeInShow : style.fadeIn}`}
      style={containerStyle}
    >
      <img className={`${images.blackFridayDecorationLeft.class} ${style.decorationLeft}`} />
      <img className={`${images.blackFridayDecorationRight.class} ${style.decorationRight}`} />
      {isUltimate && <UltimateBackground />}
      {closeVisible && (
        <CloseButton
          className={style.close}
          onClick={() => {
            native.postNativeEvent("close")
          }}
        />
      )}
      <div className={style.top}>
        <div className={style.image}>
          <img className={icon.class} />
        </div>
        <div className={style.content}>
        <Textfit
        mode="single"
        forceSingleModeWidth={false} className={titleClass}>{title(savingPercentage)}</Textfit>
          <label className={style.subtitle}>{strings.promoSubtitle(promoHours)}</label>
          <Countdown showExpires />
        </div>
      </div>
      <button
        className={style.cta}
        onClick={() => {
          blackFriday.actions.openPaywallFromBanner()
        }}
      >
        {strings.unlockDeal}
      </button>
    </div>
  )
}

const UltimateBackground = () => {
  return (
    <div className={style.ultimateContainer}>
      <img
        className={`${style.ultimateImage} ${images.ultimate.blackFriday.bannerBackground.class}`}
      />
    </div>
  )
}

export default PromoBanner
